<template>
  <nav>
    <slot>
      <a
        :href="`https://www.pitchup.com/${
          $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
        }about/`"
        target="_blank"
      >
        <translate>About</translate>
      </a>
      <nuxt-link :to="$puLocalePath({ name: 'about-faq' })">
        <translate>FAQ</translate>
      </nuxt-link>
      <a
        :href="`https://www.pitchup.com/${
          $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
        }about/contact/`"
        target="_blank"
      >
        <translate>Contact us</translate>
      </a>
      <nuxt-link :to="$puLocalePath({ path: '/terms/' })" target="_blank">
        <translate>Terms</translate>
      </nuxt-link>
      <nuxt-link :to="$puLocalePath({ path: '/privacy/' })" target="_blank">
        <translate>Privacy</translate>
      </nuxt-link>
    </slot>
  </nav>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class FooterLinks extends Vue {}

export default toNative(FooterLinks)
</script>

<style scoped>
nav {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 1em auto 0;
  gap: 8px;
  row-gap: 0;
}

nav a {
  color: var(--colour-blue);
  text-decoration: none;
  padding: 1em;
}
</style>
